
import React from 'react';
import { MultiplayerPlayer } from '../../types';

interface PlayerProgressBarProps {
    player: MultiplayerPlayer;
    isMe: boolean;
}

const PlayerProgressBar: React.FC<PlayerProgressBarProps> = ({ player, isMe }) => {
  return (
    <div>
      <div className="flex justify-between text-sm font-semibold mb-1">
        <span className={isMe ? "text-blue-600" : "text-gray-700"}>
          {player.email} {isMe && "(You)"}
        </span>
        <span className={isMe ? "text-blue-600" : "text-gray-700"}>
          {player.wpm} WPM
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-4">
        <div
          className={`h-4 rounded-full transition-all duration-200 ${isMe ? 'bg-blue-600' : 'bg-gray-500'}`}
          style={{ width: `${player.progress}%` }}
        ></div>
      </div>
    </div>
  );
};

export default PlayerProgressBar;
